var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgConfigure(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 30 30",
    width: "30px",
    height: "30px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#002851",
    d: "M 5 5 C 3.346 5 2 6.346 2 8 L 2 21 C 2 21.771 2.3002969 22.468 2.7792969 23 L 0 23 C 0 24.657 1.343 26 3 26 L 14.337891 26 C 14.548891 25.492 14.857531 25.013562 15.269531 24.601562 L 17.871094 22 L 5 22 C 4.448 22 4 21.551 4 21 L 4 8 C 4 7.449 4.448 7 5 7 L 25 7 C 25.552 7 26 7.449 26 8 L 26 14.113281 C 26.463 14.192281 26.918328 14.314375 27.361328 14.484375 C 27.605328 14.577375 27.815 14.725437 28 14.898438 L 28 8 C 28 6.346 26.654 5 25 5 L 5 5 z M 24.470703 16.015625 C 23.244141 16.086963 22.039062 16.589844 21.101562 17.527344 C 19.659562 18.968344 19.766875 20.520344 20.671875 22.027344 L 16.683594 26.015625 C 15.772594 26.926625 15.772594 28.405406 16.683594 29.316406 C 17.594594 30.227406 19.073375 30.227406 19.984375 29.316406 L 23.972656 25.328125 C 25.478656 26.233125 27.030656 26.340438 28.472656 24.898438 C 29.972656 23.398437 30.359438 21.212563 29.648438 19.351562 L 26.5 22.5 L 24 22 L 23.5 19.5 L 26.648438 16.351562 C 25.950187 16.084937 25.206641 15.972822 24.470703 16.015625 z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConfigure);
export default __webpack_public_path__ + "static/media/configure.20f7ab2476785e1c25cdd5d517010542.svg";
export { ForwardRef as ReactComponent };